document.addEventListener("DOMContentLoaded", function() {
    // Välj alla menyobjekt med submenyer
    const menuItems = document.querySelectorAll(".mobile-navigation .menu-item-has-children");

    menuItems.forEach(item => {
        // Hitta ikonen som öppnar/stänger submenyn
        const toggleIcon = item.querySelector(".open");

        // Lägg till en klickhändelse för ikonen
        toggleIcon.addEventListener("click", function(event) {
            event.preventDefault();

            // Hitta submenyn inom aktuell menypunkt
            const subMenu = item.querySelector(".sub-menu");

            // Kontrollera om submenyn är öppen
            if (subMenu.style.height && subMenu.style.height !== "0px") {
                // Stäng submenyn
                subMenu.style.height = "0px";
                toggleIcon.classList.remove("icon-remove");
                toggleIcon.classList.add("icon-add");
            } else {
                // Öppna submenyn och justera höjden till submenyns fulla innehållshöjd
                const subMenuHeight = subMenu.scrollHeight + "px";
                subMenu.style.height = subMenuHeight;
                toggleIcon.classList.remove("icon-add");
                toggleIcon.classList.add("icon-remove");
            }
        });
    });
});
//# sourceMappingURL=mobile-navigation.js.map
